export const ICacheDataSourceType = Symbol('ICache');
